// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coEYfKvlNK6z4zeNkOfU textarea{max-width:285px}`, "",{"version":3,"sources":["webpack://./src/components/ai-panel/feedback/ai-feedback-modal.scss"],"names":[],"mappings":"AAAA,+BACI,eAAA","sourcesContent":[".textarea textarea {\n    max-width: 285px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textarea": `coEYfKvlNK6z4zeNkOfU`
};
export default ___CSS_LOADER_EXPORT___;
